import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard/Dashboard";
import Login from "../pages/Login/Login";
import Signup from "../pages/Signup/Signup";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import ResetPasswordConfirm from "../pages/ResetPassword/ResetPasswordConfirm";
import OrderDetail from "../pages/OrderDetail/OrderDetail";
import Leads from "../pages/Leads/Leads";
import { useSelector } from "react-redux";
import AllClient from "../pages/All Clients/AllClient";
import Orders from "../pages/Orders/Orders";
import UnauthorizedPage from "../components/Error/UnauthorizedPage";
import NotFoundPage from "../components/Error/NotFoundPage";
import PermissionProtectedRoute from "./PermissionProtectedRoute"; // Import your component
import Home from "../pages/Home/Home";
import LeadsPage from "../pages/Leads/Leads";
import Notification from "../pages/Notifications/Notification";
import PaymentOperations from "../pages/PaymentOperations/PaymentOperations";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import WalletMain from "../pages/Wallet/WalletMain";
import ClientConnect from "../pages/ClientConnect/ClientConnect";
import AnalyticsParent from "../pages/Bdm Analytics/AnalyticsParent";
import CallAllocationOrders from "../pages/CallAllocationOrders/CallAllocationOrders";
import ClientOrders from "../pages/Client Orders/ClientOrders";
import HeirachyTeam from "../pages/HeirachyTeam/HeirachyTeam";
import Deductions from "../pages/Deductions/Deductions";
import OrderProgressTracking from "../pages/Order Progress Tracking/OrderProgressTracking";
import MoveToFLassociates from "../pages/Move To FL Associates/MoveToFLassociates";
import SubscriberAnalytics from "../pages/SubscriberAnalytics/SubscriberAnalytics";
import AllocationAdjustment from "../pages/AllocationAdjustment/AllocationAdjustment";
import FlOrderDeductions from "../pages/Fl Order Deductions/FlOrderDeductions";
import FlOrdersForPayoutParent from "../pages/Fl Orders For Payout/FlOrdersForPayoutParent";
import AcceptRejectOrdersParent from "../pages/Accept Reject Orders/AcceptRejectOrdersParent";
import CurrencyConverter from "../pages/CurrencyConverter/CurrencyConverter";
import RefrencesErrors from "../pages/RefrencesErrors/RefrencesErrors";
import Helpcenter from "../pages/HelpCenter/Helpcenter";
import UserManagement from "../pages/UserManagement/UserManagement";
import ReportsInsights from "../pages/ReportsInsights/ReportsInsights";
import ReportDataViolationForm from "../pages/ReportDataViolation/ReportDataViolationForm";
import ContactViolationLogs from "../pages/ContactViolationLogs/ContactViolationLogs";
import WordCountRequests from "../pages/WordCountRequests/WordCountRequests";
import SolutionMeta from "../pages/SolutionMeta/SolutionMeta";
import TestingManaagerAbcd from "../pages/testingmanagerabcd/TestingManaagerAbcd";
import QuotationPricing from "../pages/QuotationPricing/QuotationPricing";
import TaggedOrders from "../page-components/OrderTags/TaggedOrders";
export const AppRoutes = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, permissions } = useSelector((state) => state.auth);

  useEffect(() => {
    // Log the current state when fetching
    if (user?.access_token) {
      dispatch({ type: "FETCH_COMMON_INFO" });
    }
  }, [dispatch, location.pathname, user?.access_token]);

  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/sign-up" element={<Signup />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/reset-password/confirm/:uid/:token"
        element={<ResetPasswordConfirm />}
      />

      {/* Protected Routes */}
      <Route element={<PermissionProtectedRoute permissionsRequired={[]} />}>
        {/* <Route
          path="/sales-operations/sales-analytics"
          element={<Dashboard />}
        />{" "} */}
        <Route
          path="/sales-operations/sales-analytics"
          element={<AnalyticsParent />}
        />

        <Route path="/search=true" element={null} />
        <Route path="/" element={<Home />} />
        <Route path="/testingmanagerabcd" element={<TestingManaagerAbcd />} />

        {/* Order Management Routes */}
        {/* <Route path="/orders" element={<Orders />} /> */}
        <Route path="/order-management/my-orders" element={<Orders />} />
        <Route
          path="/order-management/order-operations/call-allocation"
          element={<CallAllocationOrders />}
        />
        <Route
          path="/order-management/order-operations/deductions"
          element={<Deductions />}
        />
        <Route
          path="/order-management/order-operations/moved-to-fl-associates"
          element={<MoveToFLassociates />}
        />
        <Route
          path="/order-management/order-operations/order-progress-tracking"
          element={<OrderProgressTracking />}
        />
        <Route
          path="/order-management/order-operations/fl-order-deduction"
          element={<FlOrderDeductions />}
        />
        <Route
          path="/order-management/order-operations/subscriber-analytics"
          element={<SubscriberAnalytics />}
        />
        <Route
          path="/order-management/order-operations/allocation-adjustment"
          element={<AllocationAdjustment />}
        />
        <Route
          path="/order-management/order-operations/fl-orders-for-payout"
          element={<FlOrdersForPayoutParent />}
        />
        <Route
          path="/order-management/order-operations/accept-reject-orders"
          element={<AcceptRejectOrdersParent />}
        />
        <Route
          path="/order-management/order-operations/flagged-submissions"
          element={<RefrencesErrors />}
        />
        <Route
          path="/order-management/order-operations/solutions-meta"
          element={<SolutionMeta />}
        />
        <Route
          path="/order-management/my-orders/:orderKey"
          element={<OrderDetail />}
        />
        <Route
          path="/order-management/tagged-orders/:uid"
          element={<TaggedOrders />}
        />
        <Route
          path="/raised-requests/word-count-requests"
          element={<WordCountRequests />}
        />
        {/* Leads Management Routes */}
        <Route path="/sales-operations/leads" element={<Leads />} />
        <Route
          path="/sales-operations/client-connect"
          element={<ClientConnect />}
        />
        <Route
          path="/sales-operations/currency-converter"
          element={<CurrencyConverter />}
        />
        <Route
          path="/sales-operations/quotation-pricing"
          element={<QuotationPricing />}
        />
        {/* Sales Operatiaons */}
        <Route path="/sales-operations/clients" element={<AllClient />} />
        {/* Payment Operations Here  */}
        <Route
          path="/payment-operations/transactions"
          element={<PaymentOperations />}
        />
        <Route path="/payment-operations/wallet" element={<WalletMain />} />
        <Route path="/notifications" element={<Notification />} />
        <Route path="/hierarchy-form" element={<HeirachyTeam />} />
        <Route path="/help-center" element={<Helpcenter />} />
        <Route path="/client-orders" element={<ClientOrders />} />

        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/reports-insights" element={<ReportsInsights />} />
        <Route
          path="/report-data-violation"
          element={<ReportDataViolationForm />}
        />
        <Route
          path="/contact-violation-logs"
          element={<ContactViolationLogs />}
        />
      </Route>

      {/* Error Handling */}
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
